import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';

export default {
  createConnection(url, options = {}) {
    return new HubConnectionBuilder()
      .withUrl(url)
      .withAutomaticReconnect([0, 2000, 5000, 10000]) // 自动重连间隔
      .configureLogging(LogLevel.Information) // 日志级别
      .build();
  },
  async startConnection(connection) {
    try {
      await connection.start();
      console.log('SignalR Connected');
      return true;
    } catch (err) {
      console.error('Connection failed:', err);
      return false;
    }
  },
  async stopConnection(connection) {
    if (connection) {
      await connection.stop();
      console.log('SignalR Disconnected');
    }
  }
};